import { FooterComponent as Footer } from "./footer.component";
export default Footer;
